var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.807 3C15.8555 4.94617 17.1896 6.82822 19.112 7.30345C19.5243 7.40541 20.0041 7.38321 20.3333 7.56327V10.6466C18.7038 10.7354 17.1451 10.1212 15.807 9.24881V16.6076C15.807 16.8946 15.4424 17.9305 15.3017 18.2405C13.3455 22.5473 7.2128 22.8696 4.82703 18.7799C2.32358 14.4888 5.85573 9.28581 10.7046 9.90658V13.1954C10.6445 13.2176 10.6059 13.1132 10.5812 13.1132H9.26444C8.88094 13.1132 7.99626 13.8277 7.75595 14.1549C6.03596 16.5007 8.68507 19.5207 11.242 18.1312C11.744 17.8582 12.5974 16.8534 12.5974 16.2787V3H15.807Z",
    fill: "#F7F7F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokIcon);
export default __webpack_public_path__ + "static/media/tiktok-icon.70856946db9d7c5eaf424dbb7a2ec2ae.svg";
export { ForwardRef as ReactComponent };